// src/components/main/PrivateRoute.jsx
import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";

const LoadingScreen = () => (
  <div
    className="fixed inset-0 z-50 grid place-items-center bg-slate-950/70 backdrop-blur-sm"
    role="status"
    aria-live="polite"
  >
    <div className="flex flex-col items-center gap-3">
      <div className="relative h-8 w-8">
        <div className="absolute inset-0 rounded-full border-2 border-white/15" />
        <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-violet-500 animate-spin" />
      </div>
      <div className="text-sm text-white/80">Загрузка…</div>
    </div>
  </div>
);

const PrivateRoute = () => {
  const { auth, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) return <LoadingScreen />;

  return auth ? (
    <Outlet />
  ) : (
    <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />
  );
};

export default PrivateRoute;
